import * as React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { buttonBuilder } from "../../views/common-forms/components";
import { AppDispatch } from "../../views/common/store";
import { apiAuthenticationRequest, settingsView, stampBeginOffline } from "../../shared/timeclock/actions";
import { deviceRequestIdentification } from "../actions/device";
import { Numpad } from "../components";
import { Session } from "../reducers";
import { Messages, SelfRegistration } from "../messages";
import { selfRegistrationBegin } from "../actions";

interface EntryProps {
    session?: Session;
    autoCompleteChars?: number;
    selfRegistrationEnabled?: boolean;
    dispatch?: AppDispatch;
}

function mapStateToProps(state) {
    return { ...state, ...state.session, ...state.config };
}

const connector = connect(mapStateToProps);

const NewEmployeeButton = buttonBuilder("new", SelfRegistration.Button);

class _Entry extends React.PureComponent<EntryProps, unknown> {
    componentDidMount(): void {
        this.UNSAFE_componentWillReceiveProps(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps: EntryProps): void {
        if (nextProps.session.deviceResults && nextProps.session.deviceResults.length > 0) {
            const dr = nextProps.session.deviceResults[0];
            this.props.dispatch(deviceRequestIdentification(dr.readerId, dr.data));
        }
    }

    render(): JSX.Element {
        const { autoCompleteChars, selfRegistrationEnabled, session } = this.props;

        return (
            <div className="entryContainer">
                <h1>
                    <FormattedMessage {...Messages.Welcome} />
                </h1>
                <Numpad
                    onNumberCompleted={this.numberComplete}
                    autoComplete={autoCompleteChars}
                    hintMessage={Messages.EntryWaiting}
                />
                {selfRegistrationEnabled && !session.loginTimerId ? (
                    <NewEmployeeButton onClick={this.startSelfRegistration} />
                ) : null}
            </div>
        );
    }

    startSelfRegistration = (): void => this.props.dispatch(selfRegistrationBegin());

    numberComplete = (code: string): void => {
        const { dispatch, session } = this.props;
        if (code === "showsettings") {
            dispatch(settingsView());
        } else if (session.loginTimerId) {
            dispatch(stampBeginOffline(null, null, code));
        } else {
            dispatch(apiAuthenticationRequest({ code }));
        }
    };
}

export const Entry = connector(_Entry);
